
import { defineComponent } from 'vue';
import ReportOptionComponent from "@/components/reportsComponents/ReportOption.vue";
import UsersListComponent from '@/views/UsersList.vue';
import NotVerifiedUsersComponent from '@/views/NotVerifiedUsers.vue';
import NotificationsComponent from '@/views/Notifications.vue';
import store from '@/store';

export default defineComponent({
    name: "UsersPage",

    components: { ReportOptionComponent, UsersListComponent, NotVerifiedUsersComponent, NotificationsComponent },

    data() {
        return {
            statusComponent: "Menu",
            options: [
                {
                    title: "کاربران",
                    path: "all",
                    icon: 'mdi-account-multiple'
                },
                {
                    title: "کاربران احراز نشده",
                    path: "Identify",
                    icon: 'mdi-account-check'
                },
                {
                    title: "اطلاع رسانی",
                    path: "Notifications",
                    icon: "mdi-bell"
                },
            ]
        }
    },

    methods: {
        changeStatusComponent(status: string): void {
            this.statusComponent = status;

            // Update the URL query parameter
            if (this.$route.query.path !== status) {
                this.$router.push({
                    query: { ...this.$route.query, path: status },
                });
            }

            // Dispatch actions based on status
            switch (status) {
                case "all":
                    store.dispatch("panel/getAllUsersRequest", { type: 'all', filters: {} });
                    break;
                case "BlockedWallets":
                    store.dispatch("panel/getAccountsBlockRequest");
                    break;
                case "Identify":
                    // No store action for Identify; just set the status
                    break;
                case "Notifications":
                    // No store action for Identify; just set the status
                    break;
                case "Reset":
                    // No store action for Identify; just set the status
                    this.resetStatusComponent();
                    break;
                default:
                    this.statusComponent = "Menu";
                    // Optionally clear the query parameter or set to default
                    this.$router.replace({
                        query: { ...this.$route.query, path: undefined },
                    });
                    break;
            }
        },

        resetStatusComponent(): void {
            this.statusComponent = "Menu";
            if (this.$route.query.path) {
                const query = { ...this.$route.query };
                delete query.path;
                this.$router.replace({ query });
            }
        },

        selectedOption(option: { title: string, path: string, icon: string }): void {
            this.changeStatusComponent(option.path)
        }
    },

    // Watch for route changes to update statusComponent
    watch: {
        "$route.query.path"(newPath: string) {
            if (newPath && newPath !== this.statusComponent) {
                this.changeStatusComponent(newPath);
            }

            if(!newPath) {
                this.resetStatusComponent();
            }
        },
    },

    mounted() {
        const path = this.$route.query.path;
        if (typeof path === 'string' && ['all', 'Identify', 'Notifications'].includes(path)) {
            this.changeStatusComponent(path);
        }
    },
})
